import { computed, getCurrentInstance } from '@vue/composition-api';
export const useHiddenRouteParams = () => {
  const vm = getCurrentInstance();
  const store = vm.proxy.$store;
  const hiddenRouteParams = computed(
    () => store.getters['hiddenRouteData/getHiddenRouteData']
  );

  return {
    hiddenRouteParams
  };
};
